import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetSlot, successGetSlot } from './SlotSlicer';
import { ISlotList } from '../../../Pages/Slot/ISlot';
import { PayloadAction } from '@reduxjs/toolkit';
import { failureAddSlot, successAddSlot } from './AddSlotSlicer';
import { failureUpdateSlot, successUpdateSlot } from './UpdateSlotSlicer';
import { failureDeleteSlot, successDeleteSlot } from './DeleteSlotSlice';
import { Phone } from '@mui/icons-material';
import {
  failureUpdateSlotOrder,
  successUpdateSlotOrder,
} from './UpdateSlotOrderSlicer';

const SlotApi = (action: PayloadAction<any>) => {
  return api.get(`levels/${action.payload}`);
};

export function* SlotCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(SlotApi, action);
    yield put(successGetSlot(response.data));
  } catch (error) {
    yield put(failureGetSlot(error));
  }
}

// add Slot
const AddSlotApi = (action: PayloadAction<ISlotList>) => {
  // const data = {
  //   level_id: action.payload.level_id,
  //   level_diagram: action.payload.level_diagram,
  //   status: action.payload.status,
  //   location_id: action.payload.location_id,
  // };

  // return api.post('/levels/create', data);

  return api.post('/levels/create', action.payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* AddSlotCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(AddSlotApi, action);
    yield put(successAddSlot(response.data));
  } catch (error) {
    yield put(failureAddSlot(error));
  }
}

// update Slot
const UpdateSlotApi = (action: PayloadAction<ISlotList>) => {
  const data = {
    level_id: action.payload.level_id,
    level_diagram: action.payload.level_diagram,
    status: action.payload.status,
    location_id: action.payload.location_id,
  };
  console.log(action.payload);

  const url = `/levels/${action.payload.id}`;

  return api.put(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* UpdateSlotCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(UpdateSlotApi, action);
    yield put(successUpdateSlot(response.data));
  } catch (error) {
    yield put(failureUpdateSlot(error));
  }
}

// update Slot order
const UpdateSlotOrderApi = (action: PayloadAction<ISlotList>) => {
  return api.patch('/levels/levelOrder', action.payload);
};

export function* UpdateSlotOrderCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(UpdateSlotOrderApi, action);
    yield put(successUpdateSlotOrder(response.data));
  } catch (error) {
    yield put(failureUpdateSlotOrder(error));
  }
}

// delete Slot
const DeleteSlotApi = (action: PayloadAction<number>) => {
  return api.delete(`/levels/${action.payload}`);
};
export function* DeleteSlotCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteSlotApi, action);
    yield put(successDeleteSlot(response.data));
  } catch (error) {
    yield put(failureDeleteSlot(error));
  }
}
